export enum UserTypesWithGuestEnum {
    Consultant = 'consultant',
    User = 'user',
    Guest = 'guest',
    Shopper = 'shopper',
}
